import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TeslaSoundConfig} from "./TeslaSoundConfig";

/**
 * Class description
 *
 * Created: 2017-12-06
 * @author jonas
 */
export class TeslaSoundPlayer {

    constructor() {}

    public playNormalWinSound(winRatioConfig:IWinRatioConfig) {
        let soundName:string = "";
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = TeslaSoundConfig.instance.TINY_WIN;
                break;
            case WinRatioType.SMALL:
                soundName = TeslaSoundConfig.instance.SMALL_WIN;
                break;
            case WinRatioType.MEDIUM:
                soundName = TeslaSoundConfig.instance.MEDIUM_WIN;
                break;
            case WinRatioType.LARGE:
                soundName = TeslaSoundConfig.instance.LARGE_WIN;
                break;
            default:
                soundName = "";
                break;
        }

        SlotGame.sound.playEffect(soundName);
    }

    public playHighlightSound(index:number) {
        switch(index) {
            case 0:
                SlotGame.sound.playEffect(TeslaSoundConfig.instance.BONUS_SYMBOL_HIGHLIGHT_1);
                break;
            case 1:
                SlotGame.sound.playEffect(TeslaSoundConfig.instance.BONUS_SYMBOL_HIGHLIGHT_2);
                break;
            case 2:
                SlotGame.sound.playEffect(TeslaSoundConfig.instance.BONUS_SYMBOL_HIGHLIGHT_3);
                break;
            default:
                console.warn("BONUS_SYMBOL_HIGHLIGHT SOUND index out of range: " + index);
        }
    }
}